// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.percentage-display[data-v-5b164750]{display:inline-flex;align-items:center;justify-content:center}.percentage-value[data-v-5b164750]{position:absolute;font-weight:200}`, "",{"version":3,"sources":["webpack://./client/components/Cards/CardMetric.vue"],"names":[],"mappings":"AAGA,qCACE,mBAAA,CACA,kBAAA,CACA,sBAAA,CAGF,mCACE,iBAAA,CACA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
